import { SectionHead, Reveal } from "@/components/common/Reveal";
import { PublicHeader } from "@/components/layout/PublicHeader";
import { SlimFooter } from "@/components/layout/SlimFooter";
import { ComingHero } from "@/components/coming-soon/ComingHero";
import { PartnerMarquee } from "@/components/sections/PartnerMarquee";
import { EnquiryForm } from "@/components/forms/EnquiryForm";
import { ContactDetails } from "@/components/sections/ContactDetails";

const SERVICES = ["Heat pumps", "Gas boilers", "Ventilation", "Mechanical fit-out", "Solar thermal"];

export default function ComingSoon() {
  return (
    <>
      <PublicHeader />
      <main data-testid="coming-soon-page">
        <ComingHero />
        <PartnerMarquee items={SERVICES} label="Services" testid="services-marquee" />
        <section id="enquiry" className="mx-auto grid max-w-7xl gap-16 px-5 py-20 sm:px-8 sm:py-28 lg:grid-cols-12" data-testid="coming-enquiry">
          <div className="lg:col-span-7">
            <SectionHead label="Project enquiry" title="Tell us about your scheme" text="Share the project details and our team will come back to you. Every enquiry goes straight to enquiries@rrhp.ie." />
            <Reveal className="mt-12">
              <EnquiryForm />
            </Reveal>
          </div>
          <Reveal className="lg:col-span-4 lg:col-start-9 lg:pt-4" delay={0.1}>
            <ContactDetails />
          </Reveal>
        </section>
      </main>
      <SlimFooter />
    </>
  );
}
